module.exports = JSON.parse('{"Export Options":"خيارات التصدير","Transparent Background":"خلفية شفافة","Image Quality":"جودة الصورة"}')